import {endpoints} from './endpoints'
import request from '../request'

export function fileUploadToReport (data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.fileUploadToReport,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}